/**
 * Centralized authentication token management utility.
 * Ensures consistent token storage and retrieval across the application.
 */

import { AUTH_TOKEN_KEY } from '../services/auth-client';

/**
 * Get the authentication token from session or local storage.
 * This matches how AuthContext stores the token.
 */
export const getAuthToken = (): string | null => {
  // Current key used across the platform
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token) return token;

  // Backward compatibility: older Spotlight code used these keys
  return (
    localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
  );
};

/**
 * Get authorization headers for API requests.
 * Returns an object with the Authorization header if a token exists.
 */
export const getAuthHeaders = (): { Authorization?: string } => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
